import { Form, DatePicker } from 'antd'
import { useEffect, useState } from 'react'
import moment from 'moment'
const basicDefault = ['', '']
const formateStrShow = 'YYYY-MM-DD'
const formateStr = 'YYYY-MM-DD HH:mm:ss'
export default function TimeDurationFormItem(props) {
  const {
    label,
    keys = ['startCreateTime', 'endCreateTime'],
    form = {},
    defaultValue = basicDefault,
    dateFormatList = [formateStrShow, formateStrShow],
    style = {},
    isShowTime= false,
    isrules = false,
    isDisableFuture = true,
    ...restProps
  } = props
  const [startKey, endKey] = keys
  const [duration, setDuration] = useState(['', ''])
  const onTimeChage = (_duration,dateString) => {
    console.log(_duration)
    console.log(dateString)
    if (_duration) {
      isShowTime ?
      setDuration([dateString[0], dateString[1]])
      :
      setDuration([_duration[0].startOf('day'), _duration[1].endOf('day')])
      if (form && form.setFieldsValue) {
        form.setFieldsValue({
          [startKey]: isShowTime ? dateString[0] : _duration[0].startOf('day').format(formateStr),
          [endKey]: isShowTime ? dateString[1] : _duration[1].endOf('day').format(formateStr)
        })
      }
    } else {
      form.setFieldsValue({
        [startKey]: '',
        [endKey]: ''
      })
    }
  }
  const disabledDate = current => isDisableFuture && current && current > moment().endOf('day')

  useEffect(() => {
    setDuration([
      defaultValue[0] && moment(defaultValue[0]),
      defaultValue[1] && moment(defaultValue[1])
    ])
    return () => {}
  }, [defaultValue])
  return (
    <>
      <Form.Item name={startKey} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={endKey} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item label={label} name='duration' rules={isrules ? [{ required: true, message: '请选择时间' }] : null}>
        <DatePicker.RangePicker
          allowClear
          disabledDate={disabledDate}
          format={dateFormatList}
          style={{ width: '100%', ...style }}
          value={duration}
          placeholder={['请选择开始时间', '请选择结束时间']}
          showTime={isShowTime}
          onChange={onTimeChage}
          {...restProps}
        />
      </Form.Item>
    </>
  )
}
